import { w } from '@tinkoff/statist-page-data';
export var getStatistQueue = function () {
    w.statistQueue = w.statistQueue || [];
    return w.statistQueue;
};
export var applyQueueHandler = function (handler) {
    var statistQueue = getStatistQueue();
    if (statistQueue.handlerApplied) {
        return;
    }
    statistQueue.handlerApplied = true;
    statistQueue.forEach(function (item) { return handler(item); });
    statistQueue.length = 0;
    statistQueue.push = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        args.forEach(function (arg) { return handler(arg); });
        return 0;
    };
};
//# sourceMappingURL=statist-queue.js.map